var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base_Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2118 10.7836V13.1211C11.2118 13.3435 11.2878 13.5317 11.4398 13.6859C11.5916 13.8401 11.7791 13.9171 12.0023 13.9171C12.2253 13.9171 12.4132 13.8401 12.566 13.6859C12.7187 13.5317 12.795 13.3435 12.795 13.1211V10.7836H15.1325C15.3549 10.7836 15.5431 10.7063 15.6973 10.5516C15.8514 10.397 15.9285 10.2095 15.9285 9.98914C15.9285 9.76881 15.8514 9.58231 15.6973 9.42964C15.5431 9.27681 15.3549 9.20039 15.1325 9.20039H12.795V6.85464C12.795 6.63881 12.7177 6.45356 12.563 6.29889C12.4083 6.14439 12.2194 6.06714 11.9963 6.06714C11.7733 6.06714 11.5868 6.14439 11.4368 6.29889C11.2868 6.45356 11.2118 6.63881 11.2118 6.85464V9.20039H8.86602C8.64368 9.20039 8.45685 9.27839 8.30552 9.43439C8.15418 9.59022 8.07852 9.77706 8.07852 9.99489C8.07852 10.2127 8.15418 10.3986 8.30552 10.5526C8.45685 10.7066 8.64368 10.7836 8.86602 10.7836H11.2118ZM6.06227 17.8504L3.51602 20.4004C3.26602 20.6504 2.97852 20.7087 2.65352 20.5754C2.32852 20.4419 2.16602 20.1988 2.16602 19.8461V3.73364C2.16602 3.30664 2.3231 2.93597 2.63727 2.62164C2.95143 2.30747 3.3221 2.15039 3.74927 2.15039H20.2493C20.6764 2.15039 21.0471 2.30747 21.3613 2.62164C21.6754 2.93597 21.8325 3.30664 21.8325 3.73364V16.2671C21.8325 16.6941 21.6754 17.0648 21.3613 17.3791C21.0471 17.6933 20.6764 17.8504 20.2493 17.8504H6.06227ZM5.39502 16.2671H20.2493V3.73364H3.74927V18.0086L5.39502 16.2671Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartChat);
export default __webpack_public_path__ + "static/media/start_chat.8f162a45823986cf2187d05a7223b391.svg";
export { ForwardRef as ReactComponent };